import { render, staticRenderFns } from "./rom.vue?vue&type=template&id=451af163&scoped=true"
import script from "./rom.vue?vue&type=script&lang=js"
export * from "./rom.vue?vue&type=script&lang=js"
import style0 from "./rom.vue?vue&type=style&index=0&id=451af163&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451af163",
  null
  
)

export default component.exports